import { render, staticRenderFns } from "./CFormGeneral.vue?vue&type=template&id=1af18a40&scoped=true&"
import script from "./CFormGeneral.vue?vue&type=script&lang=js&"
export * from "./CFormGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af18a40",
  null
  
)

export default component.exports